import * as React from 'react';
import { Box, Typography, Button, Stack, useTheme, IconButton } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import ImageUpload from '../../../components/ImageUpload';
import { createComServ } from '../../../services/com-service';
import constants from '../../../utils/Constants';
import { AddCircle, Delete } from '@mui/icons-material';
import ScrollBox from '../../../components/ScrollBox';
import CtrlLabelTxtFieldInfo from '../../../components/CtrlLabelTxtFieldInfo';


function CreateCompany() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { setLoadingScreen } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const [addrArr, setAddrArr] = useState([]);
  const [comLogo, setComLogo] = useState({ fileKey: "", fileUrl: "" });
  const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }

  function handleImgRemove() {
    setComLogo({ fileKey: "", fileUrl: "" })
  };

  function handleOnUpload({ fileKey, fileUrl }) {
    setComLogo({ fileKey, fileUrl })
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const payload = {
        comName: inputObject.comName,
        licNo: inputObject.licNo,
        taxNo: inputObject.taxNo,
        logo: comLogo.fileKey,
        contactNo: inputObject.contactNo,
        email: inputObject.email,
        webAddr: inputObject.webAddr,
        // address: inputObject.address,
        addressArr: addrArr.map((i) => ({ addr: i.addr })),
        ackTemp: `Thank you for your Order Request. We acknowledge receipt and will process it accordingly.\n\nYou can review the details by clicking the link below:\n[@{PO_LINK}]\n\nPlease feel free to reach out if you have any questions.\n\nBest regards,\n[Your Name]`,
        orderCfmTemp: 'Thank you for your Order Request. We confirm receipt and have started processing it.\n\nExpected Delivery Date: @{Expected_Date}\n\nYou can review the order details by clicking the link below:\n[@{PO_LINK}]\n\nPlease feel free to reach out if you have any questions.\n\nBest regards,\n[Your Name]',
        poTemp: 'A new Order Request has been created under @{PROJ_NAME} in @{COM_NAME}.\nYou can review the details by clicking the link below:\n[[@{PO_LINK}]]'
      }
      console.dir(payload);
      const { message } = await createComServ(payload);
      notify("success", message);
      navigate(route.aCompanies, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};

    if (!values.comName)
      errors.comName = "Company Name is required!";

    return errors;
  };

  async function handleCancel() {
    navigate(route.aCompanies, { replace: true })
  }

  const addAddr = () => {
    setAddrArr([
      ...addrArr,
      {
        addr: ""
      },
    ]);
  };

  const removeAddr = (index) => {
    const updatedAddrArr = [...addrArr];
    updatedAddrArr.splice(index, 1);
    setAddrArr(updatedAddrArr);
  };

  const handleAddrValChange = (index, e) => {
    const { name: field, value } = e.target;
    const updatedAddrArr = [...addrArr];
    updatedAddrArr[index][field] = value;
    setAddrArr(updatedAddrArr);
  };



  return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
    <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
      <Stack width={"20%"}>
        <BackButton />
      </Stack>
      <Stack width={"60%"} alignItems={"center"}>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Create Company </Typography>
      </Stack>
      <Stack width={"20%"} />
    </Stack>
    <BgBoxOld height={"93%"} py={1}>
      <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
        <Stack sx={{ width: "30%", height: "90%", gap: 1 }}>
          <LabelTxtFieldInfo name="comName" errMsg={formErrors.comName} title="Company Name *" {...txtFieldSx} />
          <LabelTxtFieldInfo name="email" title="Email ID" {...txtFieldSx} />
          <LabelTxtFieldInfo name="contactNo" title="Contact No" {...txtFieldSx} />
          <LabelTxtFieldInfo name="licNo" title="License No" {...txtFieldSx} />
          <LabelTxtFieldInfo name="taxNo" title="Tax No" {...txtFieldSx} />
          <LabelTxtFieldInfo name="webAddr" title="Website Link" {...txtFieldSx} />
        </Stack>
        <Stack sx={{ width: "30%", height: "90%" }}>
          <Stack direction={'row'} alignItems='center' mt={-2} >
            <Typography sx={{ fontSize: 15, fontWeight: "bold" }}>Addresses</Typography>
            <IconButton onClick={addAddr}>
              <AddCircle sx={{ color: theme.palette.custom.btn }} />
            </IconButton>
          </Stack>
          <Box sx={{ backgroundColor: "#ffff", borderRadius: 1.4, border: 1, height: 400, borderColor: '#E3E3E3', width: "100%", }}>
            <ScrollBox height={"100%"} >
              {addrArr.map((e, index) => (
                <Stack key={index} sx={{
                  borderRadius: 1.4, gap: 2, mb: 0.5, px: 1, py: 0.5,
                  backgroundColor: "rgba(162, 214, 249, 0.2)", width: "100%", position: "relative"
                }}>
                  <CtrlLabelTxtFieldInfo name="addr" title={`Address: ${index + 1}`} placeholder={"Enter company address....."} {...txtFieldSx} width={"100%"} multiline={true}
                    height={90} rows={5} value={e.addr} onChange={(e) => handleAddrValChange(index, e)} />
                  <IconButton
                    sx={{ position: "absolute", top: -6, right: -8 }} aria-label="delete"
                    onClick={() => removeAddr(index)}>
                    <Delete color='error' />
                  </IconButton>
                </Stack>
              ))}
            </ScrollBox>
          </Box>


          {/* <LabelTxtFieldInfo name="address" title="Address" {...txtFieldSx} rows={4} multiline={true} height={100} /> */}
        </Stack>
        <ImageUpload currentImage={comLogo?.fileUrl} onUpload={handleOnUpload} onRemove={handleImgRemove} btnName={"Upload Logo"} />
        <Box sx={{ position: "absolute", bottom: 20, right: 20 }}>
          <Button variant="outlined" onClick={handleCancel} sx={{
            fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
            color: theme.palette.custom.btn, mr: 2,
          }}>CANCEL</Button>
          <Button variant="contained" type="submit"
            sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>CREATE</Button>
        </Box>
      </Stack>
    </BgBoxOld>
  </form>
  );
}

export default CreateCompany;